const RecurveUtility = {
    networkPostHeaders: new Headers({
        'X-CSRF-TOKEN': window.session.token,
        'credentials': 'same-origin',
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"}),
    /**
     * @returns {String} relativeURI, i.e. "http://recurve.test/test"
     */
    relativeURI() {
        const storePath = window.session.store.url_path || window.session.store.urlslug;
        return `${document.location.protocol}//${window.session.store.fqdn}/${storePath}`;
    },

    /**
     * Scrolls immediately to the top of the window, regardless of component position
     */
    scrollToTopOfWindow() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },

    /**
     * @param {String} path Url of endpoint, relative to this.relativeURI()
     * @param {Object} payload Object representing the payload to be sent to the server
     * @param {Object} context `this` of current context
     * @returns {Promise} Preconstructed thennable fetch request
     * Function that can be called like fetch(), that automatically attaches network headers and relative URI
     */
    initiatePostRequest(path, payload, context) {
        context.clearErrors();
        let url = `${this.relativeURI()}/${path}`;
        return fetch(url, {
            method: 'POST',
            headers: this.networkPostHeaders,
            body: JSON.stringify(payload)
        })
    },
    /**
     *
     * @param {String} path Url of endpoint, relative to this.relativeURI()
     * @returns {Promise} Preconstructed thennable fetch request
     * @param {Object} context `this` of current context
     * Function that can be called like fetch(), that automatically attaches relative URI
     */
    initiateGetRequest(path, context) {
        this.clearErrors(context);
        let url = `${this.relativeURI()}/${path}`;
        return fetch(url, {
            method: 'GET'
        })
    },

    /**
     *
     * @param {Object} context `this` of current context
     */
    setServerError(context) {
        //Sets an error indicating server error. The page will not work again until refreshing, and may not even then
        context.setState({hasServerError: true});
    },

    /**
     * Clears errors and stops rendering error components
     * @param {Object} context `this` of current context
     */
    clearErrors(context) {
        context.setState({errors: []});
    },

    /**
     *
     */

    calculateNcaTip(tip, cart) {
        let store = session.store;
        let ncas = session.ncas;

        let amt_array = [];
        let total_amt_array = [];

        let nca_basis = parseFloat(cart.total) + parseFloat(tip);

        if (ncas.length > 0) {
            ncas.map((nca) => {
                if (nca_basis >= parseFloat(nca.minimum_amt) && nca_basis <= parseFloat(nca.maximum_amt)) {
                    if (nca.type === 'percent') {
                        // let raw_nca_amount = (tip * nca.amount).toFixed(2);
                        let raw_nca_amount = tip * nca.amount;
                        let raw_cart_total_nca = cart.total * nca.amount;
                        let amount_to_add = Math.max(parseFloat(nca.minimum_amt),parseFloat(raw_nca_amount));
                        let cart_amount_to_add = Math.max(parseFloat(nca.minimum_amt),parseFloat(raw_cart_total_nca));
                        amt_array.push(amount_to_add);
                        total_amt_array.push(cart_amount_to_add);
                    }
                }
            })
        } else {
            let tip_to_add = tip * store.nca_percent;
            amt_array.push(tip_to_add);
        }

        function calculate(total, num) {
            return total - num;
        }

        let tip_nca_total = amt_array.length > 0 ? amt_array.reduce(calculate) : 0;
        let total_nca_total = total_amt_array.length > 0 ? total_amt_array.reduce(calculate) : 0;

        return tip_nca_total + parseFloat(tip) + total_nca_total + cart.total;
    },
    search_for_item(type, id_to_seek) {
        switch (type) {
            case "item":
                for (let i=0; i < session.items.length; i++) {
                    if (session.items[i].id === id_to_seek) {
                        return session.items[i];
                    }
                }
                break;
            case "menu_id":
                for (let i=0; i < session.items.length; i++) {
                    if (session.items[i].menu_id === id_to_seek) {
                        return session.items[i];
                    }
                }
                break;
        }
    },
    deviceType() {
        //this is a function to do the js version of responsive media queries

        let is_landscape = window.matchMedia("(orientation: landscape)").matches;
        let is_portrait = window.matchMedia("(orientation: portrait)").matches;
        let w = screen.width;

        //desktop landscape
        if (w > 1280 && is_landscape) {
            return 'desktop';
        }

        //laptop desktop landscape
        if (w > 1025 && w < 1281 && is_landscape) {
            return 'small-desktop';
        }

        //desktop portrait
        if (w > 1280 && is_portrait) {
            return 'desktop-portrait';
        }

        //laptop desktop portrait
        if (w > 1025 && w < 1281 && is_portrait) {
            return 'small-desktop-portrait';
        }

        //tablet portrait
        if (w > 767 && w < 1025 && is_portrait) {
            return 'tablet-portrait';
        }

        //tablet landscape
        if (w > 767 && w < 1025 && is_landscape) {
            return 'tablet-landscape';
        }

        //tablet landscape
        if (w > 767 && w < 1025 && is_portrait) {
            return 'tablet-landscape';
        }

        //low res tablet,mobile landscape
        if (w > 480 && w < 768 && is_landscape) {
            return 'small-tablet-landscape';
        }

        //low res tablet,mobile portrait
        if (w > 480 && w < 768 && is_portrait) {
            return 'small-tablet-portrait';
        }

        //mobile portrait
        if (w > 319 && w < 481 && is_portrait) {
            return 'mobile-portrait';
        }

        //mobile landscape
        if (w > 319 && w < 481 && is_landscape) {
            return 'mobile-landscape';
        }
    }
};
export default RecurveUtility;
